import { isPlatformBrowser } from '@angular/common';
import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';

@Pipe({
  name: 'stripHTML',
  standalone: false,
})
export class StripHTMLPipe implements PipeTransform {
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  transform(value: string): string {
    // Skip if not browser
    if (!isPlatformBrowser(this.platformId)) {
      return value;
    }

    // Create a temporary element
    const temporary = document.createElement('div');

    // Add space after each paragraph and replace &nbsp; with space
    temporary.innerHTML = value
      .replace(/<\/p>/g, '</p> ')
      .replace(/&nbsp;/g, ' ');

    // Return trimmed text content
    return (temporary.textContent || temporary.innerText || '').trim();
  }
}
